import React from 'react';
import {
   Modal,
   View,
   Text,
   TouchableOpacity,
   Image,
   Platform,
} from 'react-native';
import logger from '../../utils/logger';

const CustomAlert = ({visible, x, y, message, onClose}) => {
   logger('SSS ', x);
   const yAlignItems = Platform.OS === 'android' ? y - 20 : y;
   const positionStyle = {
      position: 'absolute',
      left: x,
      top: yAlignItems,
   };

   return (
      <Modal visible={visible} transparent={true} animationType="none">
         <TouchableOpacity onPress={onClose} style={{flex: 1}}>
            <View style={[positionStyle, {width: 242, height: 181}]}>
               <Image
                  source={require('../../assets/CVV.png')}
                  style={{width: 242, height: 181}}
               />
            </View>
         </TouchableOpacity>
      </Modal>
   );
};

export default CustomAlert;
